import {ApiClientInterface} from "./clients";
import {LenderStats, MyMoney, UrlResult} from "./models";

export class MyMoneyProvider {
  constructor(private readonly apiClient: ApiClientInterface) {}

  public get(): Promise<MyMoney> {
    return this.apiClient.get("");
  }
}